import React from 'react';
import BulkEmailSender from '../components/BulkEmailSender';

const BulkEmailPage: React.FC = () => <BulkEmailSender />;

export default BulkEmailPage;
